var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-global-starfieldbasic",class:_vm.className,attrs:{"id":"globalStarfield"}},[_c('div',{staticClass:"background"},[_c('div',{staticClass:"translation",style:({
				transform: 'translate(0, ' + this.maxHeight * this.$store.state.starfieldScrollRatio * -1 + 'px)',
			})},[_c('div',{staticClass:"scale"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }